import { render } from "./MainAbout.vue?vue&type=template&id=4acd5a7d&scoped=true"
import script from "./MainAbout.vue?vue&type=script&lang=js"
export * from "./MainAbout.vue?vue&type=script&lang=js"

import "./MainAbout.vue?vue&type=style&index=0&id=4acd5a7d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4acd5a7d"]])

export default __exports__